import { useState } from "react";
import { useAuthActions } from "@convex-dev/auth/react";
import { Button, Notice } from "../components/ui";
import { WlsLogo } from "../components/WlsLogo";

function DiscordLogo() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M20.317 4.37a19.8 19.8 0 0 0-4.885-1.515 13.8 13.8 0 0 0-.625 1.274 18.27 18.27 0 0 0-5.603 0 12.6 12.6 0 0 0-.634-1.274A19.7 19.7 0 0 0 3.677 4.37C.534 9.046-.32 13.58.106 18.058a19.9 19.9 0 0 0 6.005 3.03 14.7 14.7 0 0 0 1.447-2.35 12.9 12.9 0 0 1-2.273-1.092q.286-.21.558-.437c4.383 2.026 9.14 2.026 13.47 0q.274.227.558.437a13 13 0 0 1-2.278 1.093 14.6 14.6 0 0 0 1.447 2.35 19.8 19.8 0 0 0 6.005-3.03c.5-5.19-.838-9.683-3.728-13.689M8.02 15.331c-1.316 0-2.397-1.214-2.397-2.704s1.057-2.713 2.397-2.713 2.42 1.223 2.397 2.713c0 1.49-1.057 2.704-2.397 2.704m7.975 0c-1.316 0-2.397-1.214-2.397-2.704s1.057-2.713 2.397-2.713 2.42 1.223 2.397 2.713c0 1.49-1.057 2.704-2.397 2.704" />
    </svg>
  );
}

export function LoginPage() {
  const { signIn } = useAuthActions();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const login = async () => {
    setLoading(true);
    setError("");
    try {
      await signIn("discord", { redirectTo: "/" });
    } catch {
      setError("Connexion Discord impossible. Réessayez dans un instant.");
      setLoading(false);
    }
  };

  return (
    <main className="login">
      <section className="login__panel">
        <WlsLogo size={52} title="War Legend" />
        <h1>Blacklist WLS</h1>
        <p className="login__intro">Connectez-vous avec le compte Discord autorisé.</p>
        {error && <Notice tone="error">{error}</Notice>}
        <Button loading={loading} onClick={() => void login()}>
          <DiscordLogo /> Se connecter avec Discord
        </Button>
      </section>
      <p className="login__foot">Accès réservé au staff War Legend</p>
    </main>
  );
}
